import React from "react";
import { RouteObject } from "react-router-dom";
import { HiTec } from "../layouts/HiTec";
import { PurchaseOrders } from "../pages/hi-tec/supplier/PurchaseOrders";
import { Supplier } from "../pages/hi-tec/supplier/Supplier";
import { Triggers } from "../pages/hi-tec/supplier/Triggers";
import { Collections } from "../pages/hi-tec/ecommerce/Collections";
import { Catalogs } from "../pages/hi-tec/ecommerce/Catalogs";
import { GiftCards } from "../pages/hi-tec/ecommerce/GiftCards";
import { Products } from "../pages/hi-tec/products/Products";
import { ProductVarieties } from "../pages/hi-tec/products/ProductVarieties";
import { Locations } from "../pages/hi-tec/products/Locations";
import { Transfers } from "../pages/hi-tec/ecommerce/Transfers";

export const HiTecRoutes: RouteObject[] = [
	{
		path: "/",
		element: <HiTec />,
		children: [
			{
				path: "",
				element: <div>...</div>,
			},
		],
	},
	{
		path: "products",
		element: <HiTec />,
		children: [
			{
				path: "",
				element: <Products />,
			},
		]
	},
	{
		path: "product_varieties",
		element: <HiTec />,
		children: [
			{
				path: "",
				element: <ProductVarieties/>,
			},
		]
	},
	{
		path: "locations",
		element: <HiTec />,
		children: [
			{
				path: "",
				element: <Locations/>,
			},
		]
	},
	{
		path: "shopify",
		element: <HiTec />,
		children: [
			{
				path: "collections",
				element: <Collections />,
			},
			{
				path: "transfers",
				element: <Transfers />,
			},		
			{
				path: "gift-cards",
				element: <GiftCards />,
			},	
			{
				path: "catalogs",
				element: <Catalogs />,
			},		
		],
	},	
	{
		path: "amazon",
		element: <HiTec />,
		children: [
		]
	},	
	{
		path: "takealot",
		element: <HiTec />,
		children: [
		]
	},	
	{
		path: "woocommerce",
		element: <HiTec />,
		children: [
		]
	},
	{
		path: "google_merchant_centre",
		element: <HiTec />,
		children: [
		]
	},
	{
		path: "supplier",
		element: <HiTec />,
		children: [
			{
				path: "purchase-orders",
				element: <PurchaseOrders />,
			},
			{
				path: "suppliers",
				element: <Supplier />,
			},
			{
				path: "triggers",
				element: <Triggers />,
			},
		],
	},
];

